import { grey } from '@mui/material/colors';

export const CONNECTOR_WRAPPER_WIDTH = 60;

export const CONNECTOR_THICKNESS = 2;
export const CONNECTOR_COLOR = grey[300];
export const HIGHLIGHTED_CONNECTOR_COLOR = grey[500];
